import type { MaterialSymbol } from "material-symbols";

import { SupportedExecutorsEnum } from "@/graphql.ts";

export const getComputingLabel = (key: SupportedExecutorsEnum | string): string => {
  switch (key) {
    case SupportedExecutorsEnum.Local: {
      return "Application Server (Local)";
    }
    case SupportedExecutorsEnum.Cluster: {
      return "High-Performance Cluster (HPC)";
    }
    case SupportedExecutorsEnum.Aws: {
      return "Cloud Platform (AWS)";
    }
    case "default": {
      return "Activity Default";
    }
    default: {
      return "Unknown Platform";
    }
  }
};

export const getComputingIcon = (key: SupportedExecutorsEnum | undefined | null): MaterialSymbol => {
  switch (key) {
    case SupportedExecutorsEnum.Local: {
      return "dns";
    }
    case SupportedExecutorsEnum.Cluster: {
      return "memory";
    }
    case SupportedExecutorsEnum.Aws: {
      return "cloud";
    }
    default: {
      return "unknown_5";
    }
  }
};
